<template>
    <span class="zhaw-score-icon-component">
        <span v-if="highestScore">
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
        </span>

        <span v-if="highScore">
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
        </span>

        <span v-if="middleScore">
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
        </span>

        <span v-if="lowScore">
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
        </span>

        <span v-if="lowestScore">
            <font-awesome-icon class="zhaw-score-icon" :icon="['fas', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
        </span>

        <span v-if="nullScore">
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
            <font-awesome-icon class="zhaw-score-icon" :icon="['far', 'star']"></font-awesome-icon>
        </span>
    </span>
</template>

<script>
    export default {
        name: "Score",
        props: {
            score: Number
        },
        computed: {
            highestScore: function () {
                return this.score >= 80
            },
            highScore: function () {
                return this.score < 80 && this.score >= 60
            },
            middleScore: function () {
                return this.score < 60 && this.score >= 40
            },
            lowScore: function () {
                return this.score < 40 && this.score >= 20
            },
            lowestScore: function () {
                return this.score < 20 && this.score > 1
            },
            nullScore: function () {
                return this.score === null || this.score === 0
            }
        }
    }
</script>

<style scoped>
    .zhaw-score-icon {
        color: #1266ac;
        font-size: 1rem;
        vertical-align: middle;
    }
</style>